import IconArrowRight from "@/components/icons/IconArrowRight"
import Link from "next/link"

export default function SectionHeading({heading, url, label = "View All"}: {heading: string, url?: string, label?: string}) {
  const children = <>
    <h2 className="">{heading}</h2>
    {url && <div className="flex items-center gap-4">
      <span className="">{label}</span>
      <IconArrowRight className="w-[0.875em] h-[0.875em]" />
    </div>}
  </>

  if (url) {
    return <Link href={url} className="flex items-center justify-between gap-4 text-lg leading-100">{children}</Link>
  }

  return <div className="flex items-center justify-between gap-4 text-lg leading-100">{children}</div>
}